<template>
    <section id="photo-gallery">
        <div class="container container-xl-fluid">
            <div class="secondary-heading text-center">ESSENS TURKEY 2025</div>
            <h1 class="text-center mb-5"> {{ $t('webGallery') }} </h1>
            <div class="row justify-content-center">
                <div v-for="gallery in galleries" :key="gallery" class="col-xl-4 col-lg-4 col-md-6 col-12 my-4 my-lg-5 px-lg-4">
                    <router-link :to="gallery.href" class="gallery-thumbnail d-block text-center">
                        <img :src="gallery.imgSrc" :alt="gallery.name + ' image'">
                        <div class="thumbnail-h ">{{ gallery.name }} <i class="fa fa-long-arrow-right" style="color: var(--secondary);" aria-hidden="true"></i></div>
                    </router-link>
                     <div style="padding-top: 7px; text-align: center; font-family: 10px;"><a :href="gallery.zip"><i class="fa fa-cloud-download" style="color: var(--secondary);" aria-hidden="true"></i></a></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

    const galleries = [
        { name: 'Papillon Zeugma Relaxury', href: '/gallery/hotel', imgSrc: 'https://static.essensworld.com/images/turkey_25/web/hotel.jpg', zip: 'https://static.essensworld.com/images/turkey_25/web/hotel.zip' },
        { name: 'SELUZ & ERTE COSMETICS', href: '/gallery/se' , imgSrc: 'https://static.essensworld.com/images/turkey_25/web/se.jpg', zip: 'https://static.essensworld.com/images/turkey_25/web/se.zip'},
    ]
</script>

<style>
    .thumbnail-h {
        color: var(--primary);
        text-align: center;
        font-size: 1.2rem;
        font-weight: 500;
        padding-top: 20px;
    }

    .gallery-thumbnail {
        /* border: 1px solid var(--secondary); */
    }
</style>